const palette = {
  orange: {
    /**  @property {string} extraLight  #FFE8DC */
    extraLight: '#FFE8DC',
    /**  @property {string} light  #FFEEE5 */
    light: '#FFEEE5',
    /**  @property {string} light  #FF5500 */
    base: '#FF5500',
    /**  @property {string} light  #F55200 */
    dark: '#F55200',
    /**  @property {string} light  #F55200 */
    orangeDark: '#CA4300',
    /**  @property {string} light  #C44E1A */
    darkerOrange: '#C44E1A',
    /**  @property {string} dark  #E64D00 */
    orangeAccesible: '#E64D00',
    /**  @property {string} midLight  #E64D00 */

    midLight: '#FFEEE6'
  },
  violet: {
    /** @property {string} light  undefined */
    light: '',
    /** @property {string} light  #3A0C3D */
    base: '#3A0C3D',
    /** @property {string} light  #2F0D31 */
    dark: '#2F0D31'
  },
  blue: {
    /** @property {string} light  #EBEFFD */
    light: '#EBEFFD',
    /** @property {string} light  #3a61ea */
    base: '#3a61ea',
    /** @property {string} light  #252a49 */
    dark: '#252a49',
    /** @property {string} light  #002B52 */
    blueCmineira: '#002B52',
    /** @property {string} dark  #00101F */
    blueDark: '#00101F',
    /** @property {string} midLight  #E5EAEE */
    midLight: '#E5EAEE'
  },
  lightBlue: {
    /** @property {string} light  #009CDE */
    light: '#009CDE',
    /** @property {string} light  #037CC2 */
    base: '#037CC2',
    /** @property {string} light  #037CC2 */
    lightBlueVanuncios: '#037CC2',
    /** @property {string} midLight  #E6F2F9 */
    midLight: '#E6F2F9'
  },
  yellow: {
    /** @property {string} light  undefined */
    light: '',
    /** @property {string} light  #ffdb5e */
    base: '#ffdb5e',
    /** @property {string} light  undefined */
    dark: ''
  },
  red: {
    /** @property {string} light  #F1DFE3 */
    light: '#F1DFE3',
    /** @property {string} light  #c60024 */
    base: '#c60024',
    /** @property {string} light  undefined */
    dark: ''
  },
  green: {
    /** @property {string} superLight  #EBF9EB */
    superLight: '#EBF9EB',
    /** @property {string} light  undefined */
    light: '',
    /** @property {string} light  #c60024 */
    base: '#34BE34',
    /** @property {string} accesibleGreen  #008A00 */
    accesibleGreen: '#008A00',
    /** @property {string} dark  #0D624E */
    darkPE: '#0D624E',
    /** @property {string} dark  undefined */
    dark: ''
  },
  //  TODO:rename gray colors
  neutrals: {
    grisNeutro: '#ededed',
    grisClaro: '#f3f7f8',
    grisClaroII: '#EDEDED',
    grisClaroIII: '#f5f5f5',
    grisMedio: '#e7eef0',
    grisMedioMedio: '#C8C8C8',
    grisMedioII: '#727272',
    grisOscuro: '#68808c',
    grisOscuroAccesible: '#53768a',
    grisMedioClaro: '#cbd6dc',
    grisMedioOscuro: '#7c98a7',
    grisBordes: '#ededed',
    white: '#ffffff',
    black: '#000000',
    overlay: 'rgba(0, 0, 0, 0.6)'
  }
};

export default palette;
